import React, { useState } from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { tryNativeShare } from "@/lib/share";
import SharePopupMenu from "@/components/SharePopupMenu";
import { eventUrl, fmtEventDates, pick } from "./eventUtils";

/* SHARE EVENT — native Web Share on mobile, social popup (WA/TG/X/FB/copy) elsewhere. */
export default function ShareEventButton({ event, size = "md", className = "" }) {
    const { lang } = useLang();
    const en = lang === "en";
    const [open, setOpen] = useState(false);
    const url = eventUrl(event);
    const title = pick(event, "title", lang);
    const text = `${title} — ${fmtEventDates(event, lang)} · ${event.location}\n${pick(event, "summary", lang)}`;

    const onShare = async (e) => {
        e.preventDefault(); e.stopPropagation();
        const r = await tryNativeShare({ title, text, url });
        if (r.used) { if (r.mode === "share") toast.success(en ? "Shared" : "Condiviso"); return; }
        setOpen((v) => !v);
    };

    const sz = size === "sm" ? "px-3 py-2 text-[10px]" : "px-5 py-3 text-xs";
    return (
        <div className={`relative inline-block ${className}`} onClick={(e) => e.stopPropagation()}>
            <button type="button" onClick={onShare} data-testid={`share-event-${event.slug}`}
                className={`inline-flex items-center gap-2 border border-abnormal-paper/40 hover:border-abnormal-acid hover:text-abnormal-acid text-abnormal-paper uppercase tracking-[0.2em] font-bold transition-colors ${sz}`}>
                <Share2 size={size === "sm" ? 12 : 14} /> {en ? "Share event" : "Share event"}
            </button>
            {open && (
                <SharePopupMenu text={text} url={url} title={en ? "Share event" : "Condividi evento"} onClose={() => setOpen(false)} testidPrefix={`share-event-${event.slug}`} />
            )}
        </div>
    );
}
